import React from 'react'
import {SignatureComponent} from "module/CustomField/component/input/SignatureComponent";
import {CFComponentLazyProps} from 'module/CustomField/type/CFComponentType';

const style = {textAlign: 'center'} as const

export function CustomFieldSignatureComponent(props: CFComponentLazyProps) {
	return (
		<div className={'CustomFieldSignatureComponent CustomFieldComponentBorder'} style={style}>
			<SignatureComponent {...props}/>
		</div>
	)
}